import React from 'react';
import PropTypes from 'prop-types';
import InputWithValidationMessage from '@Components/Input/InputWithValidationMessage';
import './AlertNameRow.scss';

export default class AlertNameRow extends React.PureComponent {
  render() {
    const { alertFormAlertName, setAlertFormAlertName, validateAlertName } = this.props;

    return (
      <div className="create-alert-dialog-row create-alert-dialog-row-name">
        <div className="create-alert-dialog-column-label">Alert name:</div>
        <div className="create-alert-dialog-column-content">
          <InputWithValidationMessage
            className="create-alert-name"
            classNameInput="create-alert-name-input"
            animatedPlaceholder
            onChange={setAlertFormAlertName}
            value={alertFormAlertName}
            placeholder={alertFormAlertName ? 'Name' : 'Choose a name'}
            clearButton={false}
            debounceDelay={0}
            validateValueInput={validateAlertName}
          />
        </div>
      </div>
    );
  }
}

AlertNameRow.propTypes = {
  alertFormAlertName: PropTypes.string,
  setAlertFormAlertName: PropTypes.func.isRequired,
  validateAlertName: PropTypes.func.isRequired,
};
